import type { FunctionComponent } from 'react';

import { token } from '@trello/theme';

import { SkeletonComponent } from './SkeletonComponent';
import { TrelloLogo } from './TrelloLogo';

interface RedesignedLoggedInHeaderSkeletonProps {
  backgroundColor?: string;
}

export const RedesignedLoggedInHeaderSkeleton: FunctionComponent<
  RedesignedLoggedInHeaderSkeletonProps
> = ({ backgroundColor: bgColor }) => {
  const defaultBackgroundColor = token('elevation.surface', '#FFFFFF');
  const backgroundColor = bgColor ?? defaultBackgroundColor;

  return (
    <div
      data-testid="logged-in-skeleton-header"
      style={{
        minHeight: 48,
        maxHeight: 48,
        backgroundColor,
      }}
    >
      <div
        style={{
          backgroundColor,
          height: 32,
          padding: token('space.100', '8px'),
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: token('space.400', '32px'),
        }}
      >
        <div
          style={{
            display: 'flex',
            flexGrow: 0,
            alignItems: 'center',
            gap: token('space.150', '12px'),
            padding: `0 ${token('space.050', '4px')}`,
          }}
        >
          <SkeletonComponent height={24} width={24} />
          <TrelloLogo />
        </div>
        <div
          style={{
            display: 'flex',
            flex: '1 0 auto',
            margin: `${token('space.0', '0px')} ${token('space.050', '4px')}`,
            gap: token('space.100', '8px'),
            justifyContent: 'center',
          }}
        >
          <div
            style={{
              border: `1px solid ${token('color.border', '#E1E4E8')}`,
              height: 30,
              flex: '1 1 auto',
              minWidth: 110,
              maxWidth: 780,
              borderRadius: token('border.radius.100', '3px'),
            }}
          />
          <SkeletonComponent width={68} />
        </div>
        <div
          style={{
            display: 'flex',
            flexGrow: 0,
            gap: token('space.150', '12px'),
            paddingRight: token('space.050', '4px'),
          }}
        >
          <SkeletonComponent height={24} width={24} />
          <SkeletonComponent height={24} width={24} />
          <SkeletonComponent height={24} width={24} />
          <SkeletonComponent height={24} width={24} circle />
        </div>
      </div>
    </div>
  );
};
